import { defineCssVars as s, defineStyle as c, defineStyleConfig as i } from "@chakra-ui/styled-system";
import { transparentize as t } from "@chakra-ui/theme-tools";
const o = s("badge", ["bg", "color", "shadow"]), n = c({
  px: 1,
  textTransform: "uppercase",
  fontSize: "xs",
  borderRadius: "sm",
  fontWeight: "bold",
  bg: o.bg.reference,
  color: o.color.reference,
  boxShadow: o.shadow.reference
}), b = c((e) => {
  const { colorScheme: r, theme: a } = e, l = t("".concat(r, ".500"), 0.6)(a);
  return {
    [o.bg.variable]: "colors.".concat(r, ".500"),
    [o.color.variable]: "colors.white",
    _dark: {
      [o.bg.variable]: l,
      [o.color.variable]: "colors.whiteAlpha.800"
    }
  };
}), d = c((e) => {
  const { colorScheme: r, theme: a } = e, l = t("".concat(r, ".200"), 0.16)(a);
  return {
    [o.bg.variable]: "colors.".concat(r, ".100"),
    [o.color.variable]: "colors.".concat(r, ".800"),
    _dark: {
      [o.bg.variable]: l,
      [o.color.variable]: "colors.".concat(r, ".200")
    }
  };
}), v = c((e) => {
  const { colorScheme: r, theme: a } = e, l = t("".concat(r, ".200"), 0.8)(a);
  return {
    [o.color.variable]: "colors.".concat(r, ".500"),
    _dark: {
      [o.color.variable]: l
    },
    [o.shadow.variable]: "inset 0 0 0px 1px ".concat(o.color.reference)
  };
}), h = c((e) => {
  const { colorScheme: r, theme: a } = e, l = t("".concat(r, ".400"), 0.8)(a);
  return {
    borderRadius: "full",
    [o.bg.variable]: "colors.".concat(r, ".400"),
    [o.color.variable]: "colors.white",
    _dark: {
      [o.bg.variable]: l,
      [o.color.variable]: "colors.blackAlpha.800"
    }
  };
}), u = c((e) => {
  const { colorScheme: r, theme: a } = e, l = t("".concat(r, ".200"), 0.5)(a);
  return {
    borderRadius: "full",
    _light: {
      [o.color.variable]: "colors.".concat(r, ".400")
    },
    _dark: {
      [o.color.variable]: l
    },
    [o.shadow.variable]: "inset 0 0 0px 1px ".concat(o.color.reference)
  };
}), m = {
  solid: b,
  subtle: d,
  outline: v,
  solidPill: h,
  outlinePill: u
}, p = i({
  baseStyle: n,
  variants: m,
  defaultProps: {
    variant: "subtle",
    colorScheme: "gray"
  }
});
export {
  p as badgeTheme,
  o as badgeVars
};
